import React from 'react'

export default props => (
    <footer className='main-footer'>
        <strong>
            Copyright &copy; {new Date().getFullYear()}
            <a href='' target='_blank'> Ottonelli Terraplenagem</a>.
        </strong>
    </footer>
)
